 import { Link } from 'react-router-dom';
 import { Ban, Home, LogOut, Mail } from 'lucide-react';
 import { Button } from '@/components/ui/button';
 import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
 import { supabase } from '@/integrations/supabase/client';
 import { useNavigate } from 'react-router-dom';
 
 /**
  * Dealer Suspended Page
  * Shown when a dealer user's organization has been suspended.
  * 
  * This is distinct from:
  * - DealerPendingPage (org has never been approved)
  * - DealerMemberInactivePage (org is approved but member is inactive)
  */
 export function DealerSuspendedPage() {
   const navigate = useNavigate();
   
   const handleSignOut = async () => {
     await supabase.auth.signOut();
     navigate('/dealer/login');
   };
   
   return (
     <div className="min-h-screen flex items-center justify-center bg-background p-4">
       <Card className="max-w-md w-full">
         <CardHeader className="text-center pb-2">
           <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-destructive/10 flex items-center justify-center">
             <Ban className="h-8 w-8 text-destructive" />
           </div>
           <CardTitle className="text-2xl">Account Suspended</CardTitle>
           <CardDescription className="text-base">
             Your dealership account has been suspended
           </CardDescription>
         </CardHeader>
         <CardContent className="space-y-4">
           <p className="text-sm text-muted-foreground text-center">
             Access to the Dealer Portal has been temporarily suspended. This may be due to policy violations, payment issues, or administrative review.
           </p>
           
           <div className="bg-destructive/5 border border-destructive/20 rounded-lg p-4 text-sm">
             <p className="font-medium mb-2 text-destructive">What should I do?</p>
             <ul className="list-disc list-inside space-y-1 text-muted-foreground">
               <li>Contact our support team for assistance</li>
               <li>Provide any requested documentation</li>
               <li>Allow time for review after compliance</li>
             </ul>
           </div>
           
           <div className="flex flex-col gap-3 pt-4">
             <Button asChild variant="default" className="w-full">
               <a href="mailto:dealers@geargossip.com?subject=Account%20Suspension%20Inquiry">
                 <Mail className="h-4 w-4 mr-2" />
                 Contact Support
               </a>
             </Button>
             
             <Button asChild variant="ghost" className="w-full">
               <Link to="/">
                 <Home className="h-4 w-4 mr-2" />
                 Go to Homepage
               </Link>
             </Button>
             
             <Button variant="ghost" onClick={handleSignOut} className="w-full">
               <LogOut className="h-4 w-4 mr-2" />
               Sign Out
             </Button>
           </div>
         </CardContent>
       </Card>
     </div>
   );
 }